import React from 'react';
import { useFormContext } from 'react-hook-form';
import paymentTextContent from './paymentTextContent';
import { formFields } from './paymentSelectFields';
import { CheckboxContainer, CheckboxVisual, HiddenCheckbox } from '@/components/common/CheckboxWrapper';
import {
  GiftAidWrapperLabel,
  GiftAidTextWrapper,
  GiftAidText,
  GiftAidTextBold,
  GiftAidCheckboxWrapper,
  StyledLabel
} from './GiftAidContainer.style';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const GiftAidCheckbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  checked,
  ...rest
}, ref) => (
  <CheckboxContainer>
    <HiddenCheckbox
      {...rest}
      ref={ref}
      checked={checked}
    />
    <CheckboxVisual checked={checked} />
    <StyledLabel>{label}</StyledLabel>
  </CheckboxContainer>
));

// For the benefit of debugging, as we're using a forwardRef
GiftAidCheckbox.displayName = 'GiftAidCheckbox';

interface GiftAidContainerProps {
  currencySymbol: string;
  paymentSelectState: {
    amount: number;
    giftaid: boolean;
  };
}

const { giftAidText1, giftAidText2 } = paymentTextContent;

export default function GiftAidContainer({ currencySymbol, paymentSelectState }: GiftAidContainerProps) {
  const { register } = useFormContext();

  return (
    <GiftAidWrapperLabel checked={paymentSelectState.giftaid}>
      <GiftAidTextWrapper checked={paymentSelectState.giftaid}>
        <GiftAidTextBold checked={paymentSelectState.giftaid}>
          {giftAidText1}
          {' '}
          {currencySymbol}
          {(paymentSelectState.amount / 4).toFixed(2)}
        </GiftAidTextBold>
        {' '}
        <GiftAidText checked={paymentSelectState.giftaid}>
          {giftAidText2}
        </GiftAidText>
      </GiftAidTextWrapper>
      <GiftAidCheckboxWrapper checked={paymentSelectState.giftaid}>
        <GiftAidCheckbox
          label={formFields.giftaid.label}
          id={formFields.giftaid.id}
          type={formFields.giftaid.type}
          checked={paymentSelectState.giftaid}
          value="true"
          {...register(formFields.giftaid.id)}
        />
      </GiftAidCheckboxWrapper>
    </GiftAidWrapperLabel>
  );
}
